/**
 * Format the license type text to display
 * @param licenseType the first three characters of the licenseType
 */
export default function formatLicenseTypeText(licenseType = '') {
  return (licenseType || '').slice(0, 3).toUpperCase();
}
